(function () {
  // Well-known disposable/temp-mail providers. This is a deterrent against
  // casual welcome-discount farming (someone grabbing a few throwaway
  // addresses), not a guarantee - it's a static list checked client-side,
  // so it can't catch every disposable domain and can be bypassed by
  // anyone willing to disable JS. Combine with the discount code's own
  // "limit to one use per customer" + expiry settings in Shopify Admin
  // for the parts this can't cover.
  var DISPOSABLE_DOMAINS = [
    'mailinator.com', 'guerrillamail.com', 'guerrillamail.info', 'guerrillamail.biz',
    '10minutemail.com', '10minutemail.net', 'tempmail.com', 'temp-mail.org',
    'throwawaymail.com', 'yopmail.com', 'yopmail.fr', 'yopmail.net',
    'trashmail.com', 'trashmail.net', 'getnada.com', 'dispostable.com',
    'sharklasers.com', 'fakeinbox.com', 'mintemail.com', 'mohmal.com',
    'moakt.com', 'emailondeck.com', 'maildrop.cc', 'inboxkitten.com',
    'spamgourmet.com', 'discard.email', 'discardmail.com', 'tempinbox.com',
    'mailnesia.com', 'mailcatch.com', 'mytemp.email', 'tempmailo.com',
    'burnermail.io', 'crazymailing.com', 'fake-mail.net', 'tmail.ws',
    'tempr.email', 'emailfake.com', 'mailtemp.info', '33mail.com',
  ];

  function isDisposableEmail(email) {
    var atIndex = email.lastIndexOf('@');
    if (atIndex === -1) return false;
    var domain = email.slice(atIndex + 1).trim().toLowerCase();
    return DISPOSABLE_DOMAINS.indexOf(domain) !== -1;
  }

  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    var emailInput = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('[id^="Newsletter-disposable-error--"]');
    if (!emailInput || !errorEl) return;

    emailInput.addEventListener('input', function () {
      if (!errorEl.hidden) errorEl.hidden = true;
    });

    form.addEventListener('submit', function (event) {
      if (isDisposableEmail(emailInput.value)) {
        event.preventDefault();
        errorEl.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.setAttribute('aria-describedby', errorEl.id);
        emailInput.focus();
      }
    });
  });
})();
